import React, { Fragment } from 'react';
import styled from 'styled-components';
import Accordion from '../shared/accordion';
import CreateAccountForm from '../shared/create-account-form';
import BuyButton from './buy-button';
import { FieldDefaults } from '../styled/components/sign-up';
import ConnectorSelect from '../shared/connectors/connector-select';
import CybersourcePaymentPage from '../cybersource-payment';
const SignUpForm = styled.div `
  i, b {
    font-size: 12px;
  }

  ${FieldDefaults}
`;
const AccountAndPaymentAccordions = ({ createAccountOpen, isLoggedIn, onAccountOrPaymentAccordionToggle, paymentView, accountTitleText, hidePaymentPage, showConnectors, }) => (React.createElement(Fragment, null,
    React.createElement("div", { className: "accordion-container" },
        !isLoggedIn &&
            React.createElement(Accordion, { show: createAccountOpen, onToggle: onAccountOrPaymentAccordionToggle, title: accountTitleText || '' },
                React.createElement(SignUpForm, null,
                    React.createElement(CreateAccountForm, null),
                    showConnectors && React.createElement(ConnectorSelect, null))),
        !hidePaymentPage
            ?
                React.createElement(Accordion, { show: !createAccountOpen, onToggle: onAccountOrPaymentAccordionToggle, title: 'Payment method' },
                    React.createElement(CybersourcePaymentPage, { paymentView: paymentView }))
            : React.createElement(BuyButton, { showConnectors: showConnectors }))));
export default AccountAndPaymentAccordions;
